import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { AppService } from 'src/core/services/app-service';
import { UserService } from 'src/core/http/user.service';
import { NotificationsService } from 'angular2-notifications';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { AlertSummaryService } from 'src/core/services/alert-summary.service';
import { take, finalize } from 'rxjs/operators';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { MatDialog } from '@angular/material/dialog';
import { DialogAvatarComponent } from 'src/app/shared/components/dialog-avatar/dialog-avatar.component';
import { MyProfileService } from 'src/core/http/my-profile.service';
import { envSettings } from 'src/common/constant';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent extends BaseComponent implements OnInit, AfterViewInit {
  public enviOptions = envSettings;
  public form: FormGroup;
  formSubmitted = false;

  public formPassword: FormGroup;
  formPasswordSubmitted = false;

  authUserId: any;
  userInstance: any = null;

  expansionPanelStep = 'account';

  @ViewChild('formDirective', { static: true }) formDirective;
  @ViewChild('formPasswordDirective', { static: true }) formPasswordDirective;

  constructor(
    // private router: Router,
    public dialog: MatDialog,
    // private route: ActivatedRoute,
    private appService: AppService,
    // private enumService: EnumService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private myProfileService: MyProfileService,
    private snackbarService: NotificationsService,
    public authenticationService: AuthenticationService,
    private alertSummaryService: AlertSummaryService,
  ) {
    super(authenticationService);
    this.enviOptions.headerSectionTitle = 'My Account';
    this.enviOptions.headerSectionIcon = { iconLibrary: 'material', iconName: 'person' };
  }

  ngOnInit() {
    this.createForm();
    this.authUserId = this.authenticationService.userInfo.AuthResult.AuthUserId;
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.appService.setIsLoading(true);
      this.myProfileService.geMyProfile()
      .pipe(
        take(1),
        finalize(() => { this.appService.setIsLoading(false); } )
      )
      .subscribe(result => {
        this.successLoadingUser(result);
      },
      error => {
        // console.log('Error:', error);
        this.alertSummaryService.error('Error: Cannot load the user account information.');
      });
    });
  }


  successLoadingUser(rawResult) {
    if (rawResult) {
      if (rawResult.State) {
        this.userInstance = rawResult.Data;
        // Set Form Array value
        setTimeout(() => {
          this.form.patchValue(this.userInstance);
          this.form.enable();
          this.form.get('EmailAddress').disable();
        });
    } else {
      this.alertSummaryService.error('Error: Cannot load the user account information.');
      }
    }
  }


  private createForm() {
    this.form  = this.formBuilder.group({
      // AppInstanceGroupId: ['', []],   // Not a real control, just used to store the Id
      AuthUserId: ['', []],           // Not a real control, just used to store the Id
      EmailAddress: [{ value: '', disabled: true }, []],
      LastName: [{ value: '', disabled: false }, [Validators.required, Validators.maxLength(80)]],
      FirstName: [{ value: '', disabled: false }, [Validators.required, Validators.maxLength(80)]],
      PhoneNumber: [{ value: '', disabled: false }, [Validators.maxLength(20)]],
      PagerNumber: [{ value: '', disabled: false }, [Validators.maxLength(20)]],
      // AuthUserInitial: [{ value: '', disabled: false }, []],
    });
    this.form.disable();


    this.formPassword  = this.formBuilder.group({
      CurrentPassword: ['', [Validators.required, Validators.maxLength(80), Validators.minLength(6)]],
      NewPassword: ['', [Validators.required, Validators.maxLength(80), Validators.minLength(6)]],
      RepeatNewPassword: ['', [Validators.required, Validators.maxLength(80)]],
    }, {
      validator: this.MustMatch('NewPassword', 'RepeatNewPassword')
    });
  }


  // custom validator to check that two fields match
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }


  get formControls() { return this.form.controls; }


  get formPasswordControls() { return this.formPassword.controls; }


  expansionPanelOpened(panelKey) {
    this.expansionPanelStep = panelKey;

    // if (this.formDirective) {
    //   setTimeout(() => {
    //     this.formDirective.resetForm();
    //   });
    // }
    if (this.formPasswordDirective) {
      setTimeout(() => {
        this.formPasswordDirective.resetForm();
      });
    }
  }


  onSubmit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      this.appService.setIsLoading(true);
      const formValues = this.form.getRawValue();

      this.myProfileService.saveMyProfile(formValues)
      .pipe(
        take(1), /*takeUntil(this.unsubscribe)*/
        finalize(() => { this.appService.setIsLoading(false); } )
      )
      .subscribe(
        (rawResult: any) => {
          if (rawResult && 'State' in rawResult && rawResult.State) {
            const toast = this.snackbarService.success('Account information', 'saved successfully!');
            this.appService.setRefreshMainViewYN(true);
          } else {
            if ('Messages' in rawResult && rawResult.Messages.length > 0) {
              this.alertSummaryService.error(rawResult.Messages);
            } else {
              this.alertSummaryService.error('An Error occured');
            }
          }
        },
        error => console.log('Error:', error),
      );
    } else {
      CustomValidators.validateAllFormFields(this.form);
    }
  }


  onPasswordSubmit() {
    this.formPasswordSubmitted = true;
    if (this.formPassword.valid) {
      this.appService.setIsLoading(true);
      const formValues = this.formPassword.getRawValue();

      this.myProfileService.saveMyPassword(formValues)
      .pipe(
        take(1), /*takeUntil(this.unsubscribe)*/
        finalize(() => { this.appService.setIsLoading(false); } )
      )
      .subscribe(
        (rawResult: any) => {
          if (rawResult && 'State' in rawResult && rawResult.State) {
            const toast = this.snackbarService.success('New Password', 'saved successfully!');
            this.formPasswordDirective.resetForm();
          } else {
            if ('Messages' in rawResult && rawResult.Messages.length > 0) {
              this.alertSummaryService.error(rawResult.Messages);
            } else {
              this.alertSummaryService.error('An Error occured');
            }
          }
        },
        error => console.log('Error:', error),
      );
    } else {
      CustomValidators.validateAllFormFields(this.formPassword);
    }
  }


  changeAvatarPopup() {
    const dialogRef = this.dialog.open(DialogAvatarComponent, {
      width: '1024px',
      maxWidth: 1024,
      maxHeight: '80vh',
      autoFocus: false,
      // data: { message: `This is test of modal popup for changing avatar`, button: DialogAvatarButton.OK }
    });

    dialogRef.afterClosed()
    .pipe(take(1) /*takeUntil(this.unsubscribe)*/)
    .subscribe(result => {
      if (result && result.event === 'Ok') {
        // const userInfo = this.authenticationService.userInfo;
        // if (userInfo != null) {
        //   userInfo.AuthResult.AvatarURI = result.data;
        // }
        // this.authenticationService.userInfo = userInfo;
        // // window.location.reload();
      }
    });
  }

}
